import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import Page from '../../../shared/components/ui/page/Page';
import iconsList from '../../../shared/components/ui/icons/iconsList';
import pathRouts from '../../../shared/enums/pathRoute';
import RealisticIsraelText from '../../../shared/components/pages/realisticIsrael/realisticIsraelText/RealisticIsraelText';
import RealisticIsraelCourses from '../../../shared/components/pages/realisticIsrael/realisticIsraelCourses/RealisticIsraelCourses';
import RealisticIsraelCoursesWidget from './realisticIsraelCoursesWidget/RealisticIsraelCoursesWidget';
import classes from './RealisticIsraelPage.module.css';

const RealisticIsraelPage = () => {

    const { texts, lang } = useSelector(state => state.translate);
    const navigate = useNavigate();
    const generalData = useSelector((state) => state.uiData.general);

    return (
        <Page title={texts.realisticIsraelName} icon={iconsList.realisticIsrael} onBack={() => navigate(`/${pathRouts.HOME}`)}>
            <div className={classes.RealisticIsraelPage}>
                <RealisticIsraelText description={texts.realisticIsraelDescriptionStudent} />
                <div className={classes.RealisticIsraelCourses}>
                    <div className={classes.ButtonsRow}>
                        <RealisticIsraelCourses buttonLink={generalData.realisticIsrael.studentViewBtn?.[lang]} buttonText={texts.realisticIsraelStudentBtn} showMoodleIcon={false} />
                    </div>
                    <RealisticIsraelCoursesWidget />
                </div>
            </div>
        </Page>
    );
};

export default RealisticIsraelPage;
